import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/ru';

dayjs.locale('ru');
dayjs.extend(relativeTime);
dayjs.extend(isToday);
dayjs.extend(utc);

export { dayjs };
